// Pure-CSS abstract gradient blob composition (no stock photos)
import React from "react";

export default function AbstractShape({
  variant = "gradient-warm",
  colors = ["#F5E6D3", "#E8D5C4", "#FAF9F6"],
  className = "",
  children,
  testId,
}) {
  const [c1, c2, c3] = colors;
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden noise-overlay ${variant} ${className}`}
    >
      {/* Floating blobs */}
      <div
        className="absolute -top-12 -left-10 w-72 h-72 rounded-full opacity-60 blur-3xl animate-blob"
        style={{ background: c1, animationDelay: "0s" }}
      />
      <div
        className="absolute -bottom-16 -right-10 w-80 h-80 rounded-full opacity-50 blur-3xl animate-blob"
        style={{ background: c2, animationDelay: "-6s" }}
      />
      <div
        className="absolute top-1/3 right-1/4 w-56 h-56 rounded-full opacity-40 blur-3xl animate-blob"
        style={{ background: c3, animationDelay: "-12s" }}
      />
      {/* SVG soft shapes */}
      <svg
        className="absolute inset-0 w-full h-full opacity-25"
        viewBox="0 0 400 400"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={`g-${testId || "x"}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={c1} />
            <stop offset="100%" stopColor={c2} />
          </linearGradient>
        </defs>
        <circle cx="80" cy="80" r="40" fill={`url(#g-${testId || "x"})`} />
        <circle cx="320" cy="120" r="24" fill={c2} opacity="0.6" />
        <path
          d="M50 320 Q 200 240 350 320 T 350 380"
          stroke={c2}
          strokeWidth="1.5"
          fill="none"
          opacity="0.5"
        />
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
}
